import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';

import TextInput from './../../Inputs/TextInput';
import Button from '../../Inputs/Button';
import { required, minLength, matchPass } from '../../../../utils/validators';
import i18n from '../../../../i18n/i18n.js';

const minLength8 = minLength(8, 'password');

let ChangePasswordForm = props => {
    let lng = props.language;

    return (
        <Fragment>
            <header>
                <div className="headline">
                    <h4>
                        <a
                            className="currentpage"
                            href="#"
                            style={{
                                borderBottom:
                                    '2px solid ' +
                                    props.branding.paywall_primary_color,
                            }}
                        >
                            {i18n.t('change_pass', { lng })}
                        </a>
                    </h4>
                </div>
            </header>
            <section id="userdetails">
                <div className="formelements">
                    <form
                        className="labelholder pswrfield"
                        onSubmit={props.handleSubmit}
                    >
                        <Field
                            component={TextInput}
                            id="password"
                            type="password"
                            name="password"
                            labelId="userpswd"
                            label={i18n.t('placeholder_password', { lng })}
                            validate={[required, minLength8]}
                            handleFocus={props.handleFocus}
                            active={
                                props.name === 'password' ? props.active : false
                            }
                            primaryColor={props.branding.paywall_primary_color}
                        />
                        <div className="labelholder editpswd">
                            <Field
                                component={TextInput}
                                id="newpassword"
                                type="password"
                                name="newpassword"
                                label={i18n.t('new_password', { lng })}
                                validate={[required, minLength8]}
                                handleFocus={props.handleFocus}
                                active={
                                    props.name === 'newpassword'
                                        ? props.active
                                        : false
                                }
                                primaryColor={
                                    props.branding.paywall_primary_color
                                }
                            />
                            <div className="labelholder repeatpsw">
                                <Field
                                    component={TextInput}
                                    id="repassword"
                                    type="password"
                                    name="repassword"
                                    label={i18n.t('repeat_new_password', {
                                        lng,
                                    })}
                                    autoComplete="off"
                                    validate={[required, matchPass]}
                                    handleFocus={props.handleFocus}
                                    active={
                                        props.name === 'repassword'
                                            ? props.active
                                            : false
                                    }
                                    primaryColor={
                                        props.branding.paywall_primary_color
                                    }
                                    iconName="lock-repeat"
                                />
                            </div>
                        </div>
                        <div className="buttonholder">
                            <a
                                className="back changepass"
                                onClick={props.closeModal}
                            >
                                cancel
                            </a>
                            <Button
                                text={i18n.t('update', { lng })}
                                backgroundColor={
                                    props.branding.paywall_buttons_bg_color
                                }
                                touched={
                                    props.params && props.params.anyTouched
                                }
                                errors={
                                    props.params && props.params.syncErrors
                                        ? true
                                        : false
                                }
                                isLoading={props.auth.isLoadingButton}
                            />
                        </div>
                    </form>
                </div>
            </section>
        </Fragment>
    );
};

export default reduxForm({
    form: 'accountForm',
})(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/ChangePassword/index.js